import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RestitucionService {

  private url = environment.server + environment.app + environment.api;
  
  constructor(private http: HttpClient) { }

  candidatoRestitucion(): Observable<any>{
    const url = `${this.url}candidato`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );

  }

  saldosDisponiblesRestitucion(): Observable<any>{
    const url = `${this.url}saldo-disponible`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );

  }
  

  consultaRestitucion(cedulaIdentidad:any): Observable<any>{
    const url = `${this.url}consulta`;
    return this.http.post(url, cedulaIdentidad)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );

  }

  validacionRestitucion(cedulaIdentidad:any): Observable<any>{
    const url = `${this.url}validacion`;
    return this.http.post(url, cedulaIdentidad)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );

  }

  detallePlanPago(): Observable<any>{
    const url = `${this.url}detalle-plan-pago`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );
  }

  infoCuentaRestitucion(): Observable<any>{
    const url = `${this.url}info-cuenta`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );

  }

  detalleMovimientosRestitucion(): Observable<any>{
    const url = `${this.url}detalle-movimientos`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );
  }

  resumenCuentaRestitucion(): Observable<any>{
    const url = `${this.url}resumen-cuenta`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );
  }

  resumenMovimientosRestitucion(): Observable<any>{
    const url = `${this.url}resumen-movimientos`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );

  }

  devolucionMasiva(): Observable<any>{
    const url = `${this.url}devolucion-masiva`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // Error del lado del cliente
      console.error('Ocurrió un error:', error.error.message);
    } else {
      // Error del lado del servidor
      console.error(
        `Código de estado del backend: ${error.status}, ` +
        `cuerpo: ${error.error}`);
    }
    // Retorna un observable con un mensaje de error para que el componente lo procese
    return throwError('Hubo un problema con la solicitud; por favor intenta nuevamente más tarde.');
  }

  suscripcionMandatoRestitucion(): Observable<any>{
    const url = `${this.url}autorizaciones/suscripcion`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );
  }


}
